(function (angular) {
    'use strict';

    angular.module('integration')
        /**
         *
         */
        .controller('accessTokenCtrl',
            ['$scope', 'accessTokenService', '$stateParams', 'sweetAlertService', 'growlService', 'accessTokenData', "integrationModalHelperService",
                function ($scope, accessTokenService, $stateParams, sweetAlertService, growlService, accessTokenData, integrationModalHelperService) {

                    $scope.accessTokenData = accessTokenData;

                    $scope.deleteAccessToken = function (accessToken) {
                        sweetAlertService.confirmationAlert(
                            "Are you sure?",
                            "You will not be able to recover this access token and it may affect apps that are using it!",
                            "Yes, revoke it!",
                            "No",
                            function (isConfirm) {
                                if (isConfirm) {
                                    accessTokenService.deleteAccessToken($stateParams.pickedApiSpaceId, accessToken.id).then(function (response) {
                                        $scope.accessTokenData[$scope.accessTokenData.indexOf(accessToken)] = response;
                                        growlService.success('Access Token deleted');
                                    }).catch(function (error) {
                                        growlService.danger("Access Token wasn't deleted due to: " + error.statusText);
                                    });
                                } else {
                                    growlService.success("Access Token wasn't deleted");
                                }
                            }
                        );
                    };

                    $scope.createAccessToken = function () {
                        integrationModalHelperService.openAccessTokenWizard($scope.accessTokenData);
                    }

                    $scope.seePermissions = function (accessToken) {
                        integrationModalHelperService.openAccessTokenModal(accessToken);
                    }

                }]);

})(window.angular);
